import type { RouteObject } from "react-router-dom";
import Layout from "@/components/feature/Layout";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import CategoryPage from "@/pages/category/page";
import DetailPage from "@/pages/detail/page";
import SearchPage from "@/pages/search/page";
import TopicPage from "@/pages/topic/page";
import AboutPage from "@/pages/about/page";

const routes: RouteObject[] = [
  {
    element: <Layout />,
    children: [
      { path: "/", element: <Home /> },
      { path: "/category/:categoryId", element: <CategoryPage /> },
      { path: "/detail/:videoId", element: <DetailPage /> },
      { path: "/search", element: <SearchPage /> },
      { path: "/topic/:topicId", element: <TopicPage /> },
      { path: "/about", element: <AboutPage /> },
      { path: "*", element: <NotFound /> },
    ],
  },
];

export default routes;